import React from 'react'
import { BUTTON_TYPE } from '../../../../../components/button/constants'
import ConfirmationPopup from '../../../../../components/popup/confirmationpopup/ConfirmationPopup'

const EmailRecipientCopy = ({ isPopupOpen = true, onCloseCb, onSelectAllCb = () => { }, onSelectedOnlyCb = () => { } }) => {
    return (
        <>
            <ConfirmationPopup
                title='E-Mail Recipient Copy'
                bodyText='Do you want to request Email to All recipients under selected Payer or only Selected recipients?'
                isOpen={isPopupOpen}
                confirmationButtonProps={{
                    onConfirmationCb: onSelectAllCb,
                    confirmationButtonText: "All",
                    confirmationButtonStyles: {},
                    confirmationButtonType: BUTTON_TYPE.PRIMARY,
                }}
                cancelButtonProps={{
                    onCancelCb: onSelectedOnlyCb,
                    onCloseCb: onCloseCb,
                    cancelButtonText: "Selected",
                    cancelButtonStyles: {},
                    cancelButtonType: BUTTON_TYPE.PRIMARY,
                }}
                isClose={false}
            />
        </>
    )
}

export default EmailRecipientCopy;